export enum MixpanelUserEvent {
	PAGE_VIEW = "Page View",
	BUTTON_CLICK = "Button Click",
	LINK_CLICK = "Link Click",
	LINK_LABEL = "link_label",
}

export enum MixpanelUserProperty {
	FIRST_NAME = "$first_name",
	LAST_NAME = "$last_name",
	PHONE_NUMBER = "$phone_number",
	EMAIL= "$email",
	DEVICE_ID= "$device"
}
